import React from "react";
import Grid from "@mui/material/Grid";
import { pxToRem } from "../../platform-style";
import { ButtonGroup } from "@mui/material";

interface ControlBarProp {
  leftSlotComponents?: JSX.Element;
  rightSlotComponents?: JSX.Element;
  wrapComponents?: boolean;
  hideTopBorder?: boolean;
}

export function ControlBar(props: ControlBarProp) {
  return (
    <Grid
      container
      sx={{
        borderBottom: 1,
        borderTopColor: "divider",
        borderTop: props.hideTopBorder ? 0 : 1,
        borderBottomColor: "text.disabled",
        color: "text.disabled",
        padding: pxToRem(4),
      }}
    >
      <Grid
        item
        justifyContent="flex-start"
        xs={props.rightSlotComponents ? 6 : 12}
        sx={{
          "&.MuiGrid-item": { paddingBottom: 0, paddingTop: pxToRem(4), paddingLeft: pxToRem(0) },
        }}
      >
        {/*   LEFT ICONS    */}
        {props.leftSlotComponents ? (
          <ButtonGroup
            sx={{ display: props.wrapComponents ? "block" : "flex" }}
            data-testid={"left-slot-components"}
          >
            {props.leftSlotComponents}
          </ButtonGroup>
        ) : null}
      </Grid>
      <Grid
        item
        xs={props.leftSlotComponents ? 6 : 12}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          "&.MuiGrid-item": { paddingTop: pxToRem(4), paddingBottom: 0 },
        }}
      >
        {/*   RIGHT ICONS    */}
        {props.rightSlotComponents ? (
          <ButtonGroup
            sx={{ display: props.wrapComponents ? "block" : "flex" }}
            data-testid={"right-slot-components"}
          >
            {props.rightSlotComponents}
          </ButtonGroup>
        ) : null}
      </Grid>
    </Grid>
  );
}
